import { render, staticRenderFns } from "./fire-policy-form.vue?vue&type=template&id=3ab1b3f4&scoped=true&"
import script from "./fire-policy-form.vue?vue&type=script&lang=js&"
export * from "./fire-policy-form.vue?vue&type=script&lang=js&"
import style0 from "./fire-policy-form.vue?vue&type=style&index=0&id=3ab1b3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab1b3f4",
  null
  
)

export default component.exports